module.exports = __webpack_public_path__ + "img/North Korea.55440984.svg";